var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 256,
    height: 256
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    mask: "url(#mask-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2490828,0 C62.2176926,0.0081532817 53.2898492,8.96045658 53.2979969,19.9918467 C53.2898492,31.0232369 62.2258459,39.9755402 73.257236,39.9836934 L93.2164752,39.9836934 L93.2164752,20 C93.2246229,8.96860987 84.2886262,0.0163065634 73.2490828,0 C73.257236,0 73.257236,0 73.2490828,0 L73.2490828,0 Z M73.2490828,53.3224623 L20.0407664,53.3224623 C9.00937627,53.3306156 0.0733795353,62.2829189 0.0815105351,73.314309 C0.0652262536,84.3456991 9.00122299,93.2980024 20.0326131,93.314309 L73.2490828,93.314309 C84.2804729,93.3061557 93.2164696,84.3538524 93.2083219,73.3224623 C93.2164696,62.2829189 84.2804729,53.3306156 73.2490828,53.3224623 Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.641261,73.314309 C199.649409,62.2829189 190.713412,53.3306156 179.682022,53.3224623 C168.650632,53.3306156 159.714635,62.2829189 159.722783,73.314309 L159.722783,93.314309 L179.682022,93.314309 C190.713412,93.3061557 199.649409,84.3538524 199.641261,73.314309 Z M146.424792,73.314309 L146.424792,19.9918467 C146.432939,8.96860987 137.505096,0.0163065634 126.473706,0 C115.442316,0.0081532817 106.506319,8.96045658 106.51445,19.9918467 L106.51445,73.314309 C106.498166,84.3456991 115.434162,93.2980024 126.465552,93.314309 C137.496943,93.3061557 146.432939,84.3538524 146.424792,73.314309 Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.465552,199.959234 C137.496943,199.95108 146.432939,190.998777 146.424792,179.967387 C146.432939,168.935997 137.496943,159.983693 126.465552,159.97554 L106.506313,159.97554 L106.506313,179.967387 C106.498166,190.990624 115.434162,199.942927 126.465552,199.959234 Z M126.465552,146.628618 L179.682022,146.628618 C190.713412,146.620465 199.649409,137.668161 199.641278,126.636771 C199.657562,115.605381 190.721565,106.653078 179.690175,106.636771 L126.473706,106.636771 C115.442316,106.644925 106.506319,115.597228 106.514466,126.628618 C106.506319,137.668161 115.434162,146.620465 126.465552,146.628618 L126.465552,146.628618 Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0815272421,126.636771 C0.0733795353,137.668161 9.00937627,146.620465 20.0407664,146.628618 C31.0721565,146.620465 40.0081533,137.668161 40.0000056,126.636771 L40.0000056,106.644925 L20.0407664,106.644925 C9.00937627,106.653078 0.0733795353,115.605381 0.0815272421,126.636771 Z M53.2979802,126.636771 L53.2979802,179.959234 C53.2816959,190.990624 62.2176926,199.942927 73.2490828,199.959234 C84.2804729,199.95108 93.2164696,190.998777 93.2083386,179.967387 L93.2083386,126.653078 C93.2246229,115.621688 84.2886262,106.669384 73.257236,106.653078 C62.2176926,106.653078 53.2898492,115.605381 53.2979802,126.636771 C53.2979802,126.636771 53.2979802,126.644925 53.2979802,126.636771 L53.2979802,126.636771 Z",
    fill: "#E01E5A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.52adc0270ae5b63fbf74fea1dfa5678c.svg";
export { ForwardRef as ReactComponent };